module.exports = __webpack_public_path__ + "img/icon53.ade02591.png";